import { Radio } from 'antd'
import { type RadioChangeEvent } from 'antd/lib'
import {
  forwardRef,
  useCallback,
  type ComponentPropsWithoutRef,
  type FC
} from 'react'

import { LABELS, STATUSES } from '@/constants/common/message.constants'

const { Group } = Radio

type Props = Omit<
  ComponentPropsWithoutRef<typeof Group>,
  'options' | 'optionType'
> & {
  trueLabel?: string
  falseLabel?: string
  nullLabel?: string
}

/**
 * 真偽値またはnullを選択するラジオボタン
 */
export const BoolOrNullRadioButton: FC<Props> = forwardRef<
  HTMLDivElement,
  Props
>(
  (
    {
      trueLabel = LABELS.EXISTS,
      falseLabel = LABELS.NOT_EXISTS,
      nullLabel = STATUSES.ALL,
      onChange,
      value,
      ...props
    },
    ref
  ) => {
    // input には null を設定できないため、null の場合は空文字に変換する
    const value_ = value === null ? '' : value
    const handleChange = useCallback(
      (e: RadioChangeEvent) => {
        if (onChange) {
          onChange({
            ...e,
            target: {
              ...e.target,
              value: e.target.value === '' ? null : e.target.value
            }
          })
        }
      },
      [onChange]
    )

    return (
      <Radio.Group
        ref={ref}
        value={value_}
        options={[
          {
            value: '',
            label: nullLabel
          },
          {
            value: true,
            label: trueLabel
          },
          {
            value: false,
            label: falseLabel
          }
        ]}
        onChange={handleChange}
        optionType="button"
        {...props}
      />
    )
  }
)
